import axios from "axios";
import AlertStore from '@/stores/AlertStore'
import { ENDPOINT_ENTREPRISE_MARCHE_INFOS, ENDPOINT_SEARCH } from "../constants/endpoints";

let store = {
  debug: true,

  getByEntrepriseIdAndMarcheId(entrepriseId, marcheId) {
    return axios
      .get(ENDPOINT_ENTREPRISE_MARCHE_INFOS, { params: { entrepriseId, marcheId } })
      .then(response => response.data)
      .catch(error => {
        AlertStore.pushError(error.response.data.message);
      })
  },

  search(entrepriseMarcheInfos, pageIndex, pageSize, sortOptions) {
    let url = `${ENDPOINT_ENTREPRISE_MARCHE_INFOS}${ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`
    const search = []
    search.push({ key: "entreprise", operation: '=', value: entrepriseMarcheInfos.entrepriseId })
    search.push({ key: "marche", operation: '=', value: entrepriseMarcheInfos.marcheId })

    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`
      }
    }

    return axios.post(url, search)
  },

  create(infos) {
    return axios
      .post(ENDPOINT_ENTREPRISE_MARCHE_INFOS, infos)
      .then(() => {
        AlertStore.pushSuccess('Infos créées avec succès.');
      })
      .catch(error => {
        AlertStore.pushError(error.response.data.message);
      })
  },
  update(infos) {
    return axios
      .put(ENDPOINT_ENTREPRISE_MARCHE_INFOS, infos)
      .then((value) => {
        AlertStore.pushSuccess('Infos modifiées avec succès.');
        return value.data;
      })
      .catch(error => {
        AlertStore.pushError(error.response.data.message);
      })
  },
  delete(infos) {
    return axios
      .delete(ENDPOINT_ENTREPRISE_MARCHE_INFOS, { data: infos })
      .then(() => {
        AlertStore.pushSuccess('Infos supprimées avec succès.');
      })
      .catch(error => {
        AlertStore.pushError(error.response.data.message);
      })
  },
  batchUpdate(rows, infos) {
    const updatedRows = rows.map((row) => ({
      ...row,
      ...infos
    }))

    return axios.put(`${ENDPOINT_ENTREPRISE_MARCHE_INFOS}/batch`, updatedRows)
  }
};

export default store;
